import React, { useContext } from 'react'
import { TooltipContext } from '../Tooltip'
import { renderChildren } from '../children'

interface TooltipToggleProps {
  children?: React.ReactNode
}

const TooltipToggle = ({ children }: TooltipToggleProps) => {
  const { hideTooltip, showTooltip, setToggleElement } =
    useContext(TooltipContext)
  return renderChildren(children, {
    onMouseOver: showTooltip,
    onMouseOut: hideTooltip,
    onFocus: showTooltip,
    onBlur: hideTooltip,
    ref: setToggleElement,
  }) as React.ReactElement
}

export default TooltipToggle
